export interface SearchPatientResponse {
  status: boolean;
  message: string;
  data: ShortPatient[];
}

export interface ShortPatient {
  id: number;
  firstname: string;
  lastname: string;
  birthday: Date | string;
  linked: boolean;
}
